<fieldset>
  <legend>
    {{ "common.filters" | translate }}
  </legend>

  <form [formGroup]="form" class="tw-relative">
    <div class="row">
      <!-- title -->
      <div class="sm:tw-w-1/2 md:tw-w-full tw-mt-2">
        <form-field-searcher
          [control]="form?.get('title')"
          type="text"
          fieldName="title"
          label="common.title"
          (comparisonObjectChanges)="getComparisonObject($event)"
          [resetField]="resetEvent"
        >
        </form-field-searcher>
      </div>

      <!-- originalPrice -->
      <div class="sm:tw-w-1/2 md:tw-w-full tw-mt-1">
        <form-field-searcher
          [control]="form?.get('originalPrice')"
          type="number"
          fieldName="originalPrice"
          [hasCurrency]="true"
          label="common.originalPrice"
          (comparisonObjectChanges)="getComparisonObject($event)"
          [resetField]="resetEvent"
        >
        </form-field-searcher>
      </div>

      <!-- depositPrice -->
      <div class="sm:tw-w-1/2 md:tw-w-full tw-mt-1">
        <form-field-searcher
          [control]="form?.get('depositPrice')"
          type="number"
          fieldName="depositPrice"
          [hasCurrency]="true"
          label="common.depositPrice"
          (comparisonObjectChanges)="getComparisonObject($event)"
          [resetField]="resetEvent"
        >
        </form-field-searcher>
      </div>

      <!-- expirationType -->
      <div class="sm:tw-w-1/2 md:tw-w-full tw-mt-1">
        <form-field-searcher
          [control]="form?.get('expirationType')"
          type="enum"
          fieldName="expirationType"
          label="common.type"
          enumName="ExpirationType"
          (comparisonObjectChanges)="getComparisonObject($event)"
          [resetField]="resetEvent"
        >
        </form-field-searcher>
      </div>

      <div
        class="md:tw-w-full tw-mt-1 tw-flex tw-justify-start tw-items-center"
      >
        <!-- search btn -->
        <div
          mat-ripple
          [matTooltip]="'common.search' | translate"
          class="btn btn-sm tw-flex-center tw-h-[50px] mat-ripple mat-tooltip-trigger btn-hover-rise tw-mb-1 tw-w-full tw-mt-2"
          [themeColor]="'btn'"
          (click)="onSearch()"
        >
          <i class="mdi mdi-magnify mdi-22px text-white"></i>
          <span class="tw-text-[15px]">{{ "common.search" | translate }}</span>
        </div>
      </div>
    </div>

    <i
      *ngIf="tableComparisons?.length"
      class="mdi mdi-trash-can-outline mdi-22px tw-mr-2 text-danger tw-absolute tw-cursor-pointer"
      (click)="onReset($event)"
      [matTooltip]="'common.removeAll' | translate"
      style="top: -20px; left: 0px"
    ></i>
  </form>
</fieldset>
